// lib/daimon/hosted.ts
// The hosted browser executes the ordinary Daimon tools; SIP owns audio, history and billing.
/** Existing deep-research reservation, shared by the approval UI and the server charge. */
export const RESEARCH_RESERVE_CREDITS = 3;

import type { HostedDaimonBridge } from '#types/types';
export type { HostedDaimonBinding, HostedDaimonContext, HostedDaimonTool, HostedDaimonResult, HostedDaimonBridge } from '#types/types';

declare global {
  interface Window {
    __FATER_DAIMON_HOST_ENABLED__?: boolean;
    __FATER_DAIMON_HOST__?: HostedDaimonBridge;
  }
}
